import { useTranslation } from 'next-i18next';
import { Button, TYPE } from '@common/Button/Button';
import { Modal, ModalVariant } from '@common/Modal/Modal';

export interface ConfirmationModalProps {
  text: string;
  onConfirm: () => void;
  onClose: () => void;
  isVisible?: boolean;
}

export const ConfirmationModal = ({ text, isVisible = false, onConfirm, onClose }: ConfirmationModalProps) => {
  const { t } = useTranslation('layout/userConfirmationModal');

  return (
    <Modal
      variant={ModalVariant.ALERT}
      visible={isVisible}
      onClose={onClose}
      headline={t('USER_CONFIRMATION_MODAL.TITLE')}
    >
      <p className="mb-12 text-base" dangerouslySetInnerHTML={{ __html: text }} />

      <div className="flex justify-between gap-3.5">
        <Button
          text={t('USER_CONFIRMATION_MODAL.CONFIRMATION_BUTTON')}
          className="flex-1"
          onClick={() => {
            onConfirm();
            onClose();
          }}
        />
        <Button
          className="flex-1"
          type={TYPE.SECONDARY}
          text={t('USER_CONFIRMATION_MODAL.ABORT_BUTTON')}
          onClick={onClose}
        />
      </div>
    </Modal>
  );
};
